// tslint:disable-next-line:max-line-length
// [All the interactions with the WebSocketSubject should be isolated in a separate service as follows:](https://javascript-conference.com/blog/real-time-in-angular-a-journey-into-websocket-and-rxjs/)
import { Injectable } from '@angular/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { environment } from '../../environments/environment';
import { catchError, tap, switchAll } from 'rxjs/operators';
import {EMPTY, Observable, PartialObserver, Subject} from 'rxjs';
// export const WS_ENDPOINT = environment.wsEndpoint;
// todo get it from .env or serverless.env.yml file
export const WS_ENDPOINT = 'wss://5xsn8ribf6.execute-api.eu-central-1.amazonaws.com/dev';
export const RECONNECT_INTERVAL = 600;


@Injectable({
  providedIn: 'root'
})
export class WebsocketDataService {
  public wsEndpoint = WS_ENDPOINT;
  private socket$: WebSocketSubject<any>;
  private messagesSubject$ = new Subject();
  public messages$: Observable<any> = this.messagesSubject$.pipe(switchAll(), catchError(e => {
    console.log(`websocket-data.service.ts => ${e}`);
    throw e;
  }));

  constructor() {
  }

  /**
   * Creates a new WebSocket subject and send it to the messages subject
   * @param cfg if true the observable will be retried.
   */
  public connect(): void {

    if (!this.socket$ || this.socket$.closed) {
      this.socket$ = this.getNewWebSocket();
      const messages = this.socket$.pipe(
        tap({
          error: error => console.log(error),
        }),
        catchError(_ => EMPTY
        ));
      this.messagesSubject$.next(messages);
      // messages.subscribe(this.messagesSubject$); // almost similar and workable with the previous line
    }
  }

  public getObservers(): any {
    return this.messagesSubject$.observers;
  }
  private getNewWebSocket(): any {
    return webSocket({
        url: WS_ENDPOINT,
        openObserver: {
          next: () => {
            console.log('[WebSocket DataService]: connection ok');
          },
          error: (err) => {
            console.log(`websocket-data.service.ts => error ${err}`);
          }
        }
      }
    );
  }
  sendMessage(msg: any): void {
    this.socket$.next(msg);
  }
  close(): void {
   this.socket$.complete();
   // this.socket$.closed = true;
  }

}
